
import { apiInstance } from "../apiInstance";
import { createQueryString } from "../helpers/queryHelpers";

export const getLeagues = async (filters) => {
	const queryString = createQueryString(filters);
	const url = queryString ? `leagues?${queryString}` : "leagues";
	const res = await apiInstance.get(url);
	return res;
};

export const getLeague = async (leagueIdentifier) => {
	const res = await apiInstance.get(`leagues/${leagueIdentifier}`);
	return res;
};

export const updateLeague = async (leagueIdentifier, league) => {
	const res = await apiInstance.put(`leagues/${leagueIdentifier}`, league);
	return res;
};

export const getLeagueTeams = async (leagueIdentifier) => {
	const res = await apiInstance.get(`leagues/${leagueIdentifier}/teams`);
	return res;
};